export enum TurnOffReason {
    TOTAL_LOSS = 'TOTAL_LOSS',
    CAR_BOUGHT_BY_CLIENT = 'CAR_BOUGHT_BY_CLIENT',
    CONTRACT_CANCELLED_WITHOUT_PURCHASE = 'CONTRACT_CANCELLED_WITHOUT_PURCHASE',
    DEBT_COLLECTION_REPOSSESSION = 'DEBT_COLLECTION_REPOSSESSION',
    THEFT = 'THEFT',
    OTHER = 'OTHER'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/TurnOffReasonEnumTypes.ts